import { ScreenNames } from '@hrms/common/routes/screens';
import { ComponentsMap } from '@hrms/common/routes/components';
import { RouteConstantsInterface } from '@hrms/common/constant/types';
import { ModuleRoutesComponentInterface } from '@hrms/common/routes/types';
import { ModuleConstants } from '@hrms/common/constant/modules';
import { generateImage } from '@hrms/common/utils/generateImage';

export enum RouteConstantEnums {
  ATTENDANCE_LOG,
  MULTI_SESSION,
}

export const RouteConstants: RouteConstantsInterface = {
  ATTENDANCE_LOG: '/attendance-log',
  MULTI_SESSION: '/attendance-log/multi-session',
};
const getAttendanceModuleRoutes: ModuleRoutesComponentInterface = () => {
  return [
    {
      id: ModuleConstants.ATTENDANCE_LOG,
      route: RouteConstants.ATTENDANCE_LOG,
      title: ScreenNames.ATTENDANCE_LOG,
      icon: generateImage({
        noScale: true,
        name: 'attendance-log',
        alt: 'attendance-log',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.ATTENDANCE_LOG,
      children: [
        {
          id: ModuleConstants.ATTENDANCE_LOG,
          route: `${RouteConstants.MULTI_SESSION}/:EmployeeShiftId`,
          title: ScreenNames.MULTI_SESSION,
          component: ComponentsMap.MULTI_SESSION,
          sidebarVisibility: false,
        },
      ],
    },
  ];
};

export { getAttendanceModuleRoutes };
